import { useNavigation, useRoute } from '@react-navigation/native'
import { useTabInvoice } from '../../store/ScreensStore/Supplier/supplierInvoiceTab'
import { paths } from '../../screens/links'
import { useTabAccount } from '../../store/ScreensStore/Supplier/SupplierAccountsTab'
import { CustomerAccountType } from '@linqpal/models/src/dictionaries/customerAccountType'

export const useSupplierHomeAccountInvoice = () => {
  const navigation = useNavigation()
  const route = useRoute()
  const tabAccount = useTabAccount()
  const tabInvoice = useTabInvoice()

  return {
    addAccount: () => {
      if (route.name === paths.Console.customers._self) {
        let type = CustomerAccountType.TradeCredit

        if (
          window.location.pathname.endsWith(
            paths.Console.customers.home.ArAdvance,
          )
        ) {
          type = CustomerAccountType.IHC
        }

        tabAccount.createCustomer(type)
      } else {
        navigation.navigate(paths.Console.customers._self, {
          screen: paths.Console.customers.home._self,
          params: {
            screen: paths.Console.customers.home.TradeCredit,
            create: true,
          },
        })
      }
    },
    addInvoice: () => {
      const { Receivables } = paths.Console
      if (route.name === Receivables._self && tabInvoice.type === 'invoice') {
        tabInvoice.showCreateSideBar()
      } else if (route.name === Receivables._self) {
        navigation.navigate(Receivables.ReceivableList.Invoices)
        tabInvoice.showCreateSideBar()
      } else if (route.name === paths.Console.ArAdvanceInvoices._self) {
        tabInvoice.showCreateSideBar()
      } else {
        navigation.navigate(Receivables._self, {
          screen: Receivables.ReceivableList._self,
          params: {
            screen: Receivables.ReceivableList.Invoices,
            create: true,
          },
        })
      }
    },
  }
}
